import { render, staticRenderFns } from "./page.vue?vue&type=template&id=80aec19c&"
import script from "./page.vue?vue&type=script&lang=ts&"
export * from "./page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports